/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

/**
 * @import { IAnalyticsTracker } from '.'
 */

/**
 * @implements {IAnalyticsTracker}
 */
export default class AnalyticsTrackerNoop {
  /** @type {IAnalyticsTracker['trackAnalytics']} */
  async trackAnalytics(content) {}
}
